import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { FeedbackLauncher } from "@/components/FeedbackLauncher";
import logoMark from "@/assets/logo-mark.png";

/**
 * Layout das páginas de conteúdo (institucionais e guias).
 * Header/footers simples, sem mapa nem calculadora — só texto.
 */
export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header className="sticky top-0 z-30 h-16 border-b border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80">
        <div className="mx-auto flex h-full w-full max-w-3xl items-center gap-4 px-4">
          <Link to="/" className="flex shrink-0 items-center gap-2">
            <img src={logoMark} alt="Logo TrajetoFácil" width={36} height={36} className="size-9 rounded-xl" />
            <div className="hidden sm:block">
              <p className="text-lg font-extrabold leading-none tracking-tight text-foreground">TrajetoFácil</p>
              <p className="text-xs text-muted-foreground">roteirizador grátis: rota, pedágio e combustível</p>
            </div>
          </Link>
          <nav className="ml-6 hidden items-center gap-4 text-sm font-medium text-muted-foreground lg:flex">
            <Link to="/como-funciona" className="transition hover:text-foreground">Como funciona</Link>
            <Link to="/recursos" className="transition hover:text-foreground">Recursos</Link>
            <Link to="/guias" className="transition hover:text-foreground">Guias</Link>
            <Link to="/casos-de-uso" className="transition hover:text-foreground">Casos de uso</Link>
            <Link to="/sobre" className="transition hover:text-foreground">Sobre</Link>
          </nav>
          <FeedbackLauncher className="ml-auto shrink-0" />
        </div>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-10">{children}</main>

      <footer className="border-t border-border px-4 py-8 text-center text-xs text-muted-foreground">
        <nav className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-x-4 gap-y-2">
          <Link to="/" className="transition hover:text-foreground">Calculadora</Link>
          <Link to="/como-funciona" className="transition hover:text-foreground">Como funciona</Link>
          <Link to="/metodologia" className="transition hover:text-foreground">Metodologia</Link>
          <Link to="/recursos" className="transition hover:text-foreground">Recursos</Link>
          <Link to="/guias" className="transition hover:text-foreground">Guias</Link>
          <Link to="/casos-de-uso" className="transition hover:text-foreground">Casos de uso</Link>
          <Link to="/sobre" className="transition hover:text-foreground">Sobre</Link>
          <Link to="/contato" className="transition hover:text-foreground">Contato</Link>
          <Link to="/privacidade" className="transition hover:text-foreground">Privacidade</Link>
          <Link to="/termos" className="transition hover:text-foreground">Termos de uso</Link>
        </nav>
        <p className="mt-4 mx-auto max-w-2xl">
          Estimativa com base nas tarifas oficiais vigentes das praças de pedágio (ANTT e
          concessionárias estaduais), atualizadas automaticamente. O valor pago pode variar por
          sentido, tag ou desconto.
        </p>
        <p className="mt-2">TrajetoFácil · valores de pedágio e combustível são estimativas</p>
      </footer>
    </div>
  );
}
